import { useEffect, useState } from 'react'

const useClipboard = (resetIn = 1500) => {
  const [hasCopied, setHasCopied] = useState(false)

  const onCopy = async (text?: string) => {
    if (!!text && navigator?.clipboard) {
      await navigator.clipboard.writeText(text)

      setHasCopied(true)
    }
  }

  useEffect(() => {
    let timeoutId

    if (hasCopied) {
      timeoutId = setTimeout(() => {
        setHasCopied(false)
      }, resetIn)
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [resetIn, hasCopied])

  return { onCopy, hasCopied }
}

export default useClipboard
